import apiClient from './apiClient';

const permissionsAPI = {
  // Fetch the calling user's effective permissions
  getMyPermissions: () => apiClient.get('/api/permissions/my'),

  // Fetch all role→permission mappings for the company (Admin only)
  getRolePermissions: () => apiClient.get('/api/permissions/roles'),

  // Fetch grouped permission definitions for the checkbox UI (Admin only)
  getDefinitions: () => apiClient.get('/api/permissions/definitions'),

  // Save updated permissions for a role
  updateRolePermissions: (role, permissions) =>
    apiClient.put(`/api/permissions/roles/${role}`, { permissions }),

  // Reset a role's permissions to system defaults
  resetRolePermissions: (role) =>
    apiClient.post(`/api/permissions/roles/reset/${role}`),
};

export default permissionsAPI;
